import { Skill, ExerciseType } from "@tt-app/models";
import { EXERCISE_CONFIGS, EXERCISE_ICONS, SKILL_TITLE } from "@tt-app/constants";

export function getExerciseIcon(exerciseType: ExerciseType, skill?: Skill): string {
  if (exerciseType && skill) {
    return EXERCISE_CONFIGS[exerciseType][skill]?.icon || "";
  } else {
    return EXERCISE_ICONS[exerciseType];
  }
}

export function getSkillTitle(exerciseType: ExerciseType, skill: Skill): string {
  if (!skill) {
    return `exercise.function.${String(exerciseType)}`;
  } else {
    return SKILL_TITLE[skill];
  }
}
